(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory();
  } else {
    // Browser globals (root is window)
    root.LauncherAppInterface = factory();
  }
}(this, function () {
  'use strict';

  var LauncherAppInterface = {
    isAtHospitalSessionKey: 'isAtHospitalSessionKey',

    /**
     * Returns a boolean indicating whether the javascript is currently being rendered through the launcher application.
     * First priority is to utilize the sessionStorage object to see if a value was explicitly set. This use case is for development
     * where getting a device running the launcher app is not feasible.
     *
     * @method isAtHospital
     * @return {boolean} true if the device is running the launcher app, otherwise false.
     */
    isAtHospital: function() {
      // If sessionStorage exists...
      if (typeof sessionStorage !== 'undefined') {
        var sessionValueOverride = sessionStorage.getItem(this.isAtHospitalSessionKey);

        // The value in the session takes highest priority if it exists (some browsers store all session vars as strings)
        if (sessionValueOverride !== undefined && sessionValueOverride !== null) {
          var sessionValueOverrideIsTrueString = typeof sessionValueOverride === 'string' && sessionValueOverride === 'true';
          return sessionValueOverride === true || sessionValueOverrideIsTrueString;
        }
      }
      return false;
    },

    /**
     * Sets a value in sessionStorage so that when making the isAtHospital check, the method will determine the device is at home,
     * making it return false. This is primarily for development.
     *
     * @method setAtHome
     */
    setAtHome: function() {
      sessionStorage.setItem(this.isAtHospitalSessionKey, false);
    },

    /**
     * Sets a value in sessionStorage so that when making the isAtHospital check, the method will determine the device is at the
     * hospital, making it return true. This is primarily for development.
     *
     * @method setAtHome
     */
    setAtHospital: function() {
      sessionStorage.setItem(this.isAtHospitalSessionKey, true);
    }
  };

  window.launcherAppInterface = LauncherAppInterface;

  return LauncherAppInterface;
}));
